import * as React from 'react';

const CloseIcon = ({ width = 24, height = 24, stroke = '#8B8AA8', ...props }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" {...props}>
        <path stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 6 6 18M6 6l12 12" />
    </svg>
);

export default CloseIcon;
